import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form } from "reactstrap";
import useRequests from '../../../Utils/useRequests';

const ChangeStatusSpecialEquipment = ({ item, onClose }) => {
  const { postRequest } = useRequests();
  const [loading, setLoading] = useState(false);

  const newStatus = item.status === "Enable" ? "Disable" : "Enable";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      se_id: item.se_id,
      status: newStatus
    };
    const res = await postRequest('change-status-special-equipment', JSON.stringify(payload));
    setLoading(false);
    onClose(res && res.code === 200 ? 'success' : 'error', res.message);
  };

  return (
    <Modal isOpen toggle={() => onClose()}>
      <ModalHeader toggle={() => onClose()}>
        Change Status
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          Are you sure you want to change status to <b>{newStatus.toUpperCase()}</b>?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Yes, Change"}
          </Button>
          <Button color="secondary" onClick={() => onClose()}>Cancel</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ChangeStatusSpecialEquipment;